import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "button", "gradient"];

  connect() {
    this.collapsedHeight = parseFloat(window.getComputedStyle(this.contentTarget).maxHeight) || 0;

    this.showMoreText = this.buttonTarget.dataset.showMore;
    this.showLessText = this.buttonTarget.dataset.showLess;
    this.expanded = false;

    if (this.contentTarget.scrollHeight <= this.collapsedHeight) {
      this.buttonTarget.classList.add("hidden");
      this.gradientTarget.classList.add("hidden");
    }
  }

  toggle(event) {
    event.preventDefault();

    if (this.expanded) {
      this.contentTarget.style.maxHeight = `${this.collapsedHeight}px`;
      this.buttonTarget.textContent = this.showMoreText;
      this.gradientTarget.classList.remove("hidden");
    } else {
      this.contentTarget.style.maxHeight = "none";
      this.buttonTarget.textContent = this.showLessText;
      this.gradientTarget.classList.add("hidden");
    }

    this.expanded = !this.expanded;
  }
}
